import { techblogPage, techblogSearchKeyword } from '../techblog.state';
import { useAtom, useAtomValue } from 'jotai';
import { useGetTechblogInfo, useGetTechblogList } from './api';

import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';
import { useEffect } from 'react';
import { useMediaQuery } from '@mantine/hooks';
import { useReplaceQueryParams } from '@/utils/utils';
import { useScrollInit } from '@/utils/hook';

export const useGetTechblogCardData = () => {
  const isMobile = useMediaQuery(themeVariables.layout.mobile);

  const { tag, keyword } = useAtomValue(techblogSearchKeyword);
  const { queryParams, urlSearchParams, setQueryParams } =
    useReplaceQueryParams();

  const company = queryParams.get('company_id') || '';

  const [page, setPage] = useAtom(techblogPage);

  useEffect(() => {
    setPage(+(queryParams.get('page') || 1));
  }, []);

  const { data: blogList, isFetching } = useGetTechblogList({
    page,
    tag,
    keyword,
    company,
  });

  const { data: totalPage } = useGetTechblogInfo({ keyword, tag });

  useEffect(() => {
    mixpanelTrack('TechblogListPage', 'Viewed', {
      contentList: blogList?.map((item) => item.id),
    });
  }, [tag, keyword, page]);

  const handlePageChange = (page) => {
    useScrollInit(isMobile ? 'techblog-top' : 'header-top');

    setPage(page);

    urlSearchParams.set('page', page);
    setQueryParams(urlSearchParams);
  };

  return {
    blogList,
    isLoading: isFetching,
    page,
    totalPage,
    handlePageChange,
  };
};
